var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElrond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.01085 6.5201L10.8997 8.55714C10.9639 8.58388 11.0361 8.58388 11.1003 8.55714L15.9892 6.5201C16.1156 6.46741 16.2613 6.52161 16.3226 6.64416L16.9724 7.94386C17.0343 8.06761 16.9887 8.21814 16.8686 8.28679L11.7604 11.2057L16.8686 14.1247C16.9887 14.1933 17.0343 14.3439 16.9724 14.4676L16.3226 15.7673C16.2613 15.8899 16.1156 15.9441 15.9892 15.8914L11.1003 13.8543C11.0361 13.8276 10.9639 13.8276 10.8997 13.8543L6.01085 15.8914C5.88438 15.9441 5.73869 15.8899 5.67742 15.7673L5.02756 14.4676C4.96569 14.3439 5.01127 14.1933 5.13139 14.1247L10.2396 11.2057L5.13139 8.28679C5.01127 8.21814 4.96569 8.06761 5.02756 7.94386L5.67742 6.64416C5.73869 6.52161 5.88438 6.46741 6.01085 6.5201Z",
    fill: "#23F7DD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElrond);
export default __webpack_public_path__ + "static/media/elrond.e9dde42220beb8df23984fabd469c5d9.svg";
export { ForwardRef as ReactComponent };